<div class="fcp-accordion">
    <ng-content></ng-content>
</div>
